import { useState, useEffect } from "react";
import { CaseServices } from "../../../services/CaseServices";
import DocumentIcon from "../../../assets/documentIcon.svg";
import DownloadIcon from "../../../assets/downloadIcon.svg";
import SearchIcon from "../../../assets/searchIcon.svg";
import RemoveIcon from "../../../assets/deleteIcon.svg";
import DownloadIconGreen from "../../../assets/downloadIconGreen.svg";
import { AuthServices } from "../../../services/AuthServices";
import downloadPdf from "../../../utils/downloadPdfUtil";
import { handleApiErrorResponses } from "../../../utils/ApisErrorHandling";
import { CircularProgress } from "@mui/material";
import ReviewDocumentModel from "../updatedocuments/reviewDocumentModal";
import JSZip from "jszip";
import { saveAs } from "file-saver";
const DownloadDocuments = ({
  caseId,
  patientName,
  hospitalName,
  registrationId,
  tmsVersion,
}) => {
  const [mappedDocuments, setMappedDocuments] = useState(null);
  const [documentDownloading, setDocumentDownloading] = useState(null);
  const [pdfDocName, setPdfDocName] = useState("");
  const [processingPdf, setProcessingPdf] = useState(false);
  const [mergeDocumentDownloading, setMergeDocumentDownloading] =
    useState(null);
  const [documentSubDownloading, setDocumentSubDownloading] = useState(null);
  const [selectedDocuments, setSelectedDocuments] = useState([]);
  const [pdfList, setPdfList] = useState([]);
  const [searchKey, setSearchKey] = useState("");
  const [percentage, setPercentage] = useState(0);
  const [netSpeed, setNetSpeed] = useState(0);
  const [isDownloadingSelected, setIsDownloadingSelected] = useState(false);

  // Natural sort function for alphanumeric strings
  const naturalSort = (a, b) => {
    return a.documentName.localeCompare(b.documentName, undefined, {
      numeric: true,
      sensitivity: "base",
    });
  };

  // Function to clear all selections
  const clearAllSelections = () => {
    const clearedData = mappedDocuments?.map((documentType) => {
      documentType.value = documentType.value.map((doc) => ({
        ...doc,
        isSelected: false,
      }));
      return documentType;
    });
    setMappedDocuments(clearedData);
  };

  const generatePDFUsingPython = async (images, documentName) => {
    const imagesUrl = images.map((image) => ({
      image: image.documentUrl,
      compressionPossible: true,
    }));

    if (imagesUrl.length > 0) {
      try {
        const targetSize = tmsVersion === "1.0" ? 500 : 1024;
        let response = await AuthServices.loadImagesBase64UsingPython(
          { images: imagesUrl },
          setPercentage,
          setNetSpeed,
          targetSize
        );

        downloadPdf(
          response.data,
          `${documentName}`,
          registrationId,
          patientName,
          hospitalName
        );
      } catch (error) {
        handleApiErrorResponses(error);
      }
    } else {
      window.alert("No Document Uploaded Yet");
    }
    setDocumentDownloading(null);
    setMergeDocumentDownloading(null);
    setDocumentSubDownloading(null);
  };

  const generatePdfList = async () => {
    setProcessingPdf(true);
    let imagesUrl = [];
    for (let doc of selectedDocuments) {
      for (let image of doc?.documenturlmasters) {
        imagesUrl.push({
          image: image.documentUrl,
          compressionPossible: true,
        });
      }
    }
    if (imagesUrl.length > 0) {
      try {
        const targetSize = tmsVersion === "1.0" ? 500 : 1024;
        let response = await AuthServices.loadImagesBase64UsingPython(
          { images: imagesUrl },
          setPercentage,
          setNetSpeed,
          targetSize
        );

        setPdfList([
          ...pdfList,
          { docName: pdfDocName, pdfBlob: response?.data },
        ]);
        setPdfDocName("");
        setSelectedDocuments([]);

        //Resetting the selected docs to not selected
        let data = mappedDocuments.map((doc, idx) => {
          doc.value = doc.value?.map((item) => {
            return { ...item, isSelected: false };
          });
          return { ...doc };
        });
        setMappedDocuments([...data]);
      } catch (error) {
        handleApiErrorResponses(error);
      }
    } else {
      window.alert("No Document Uploaded Yet");
    }
    setProcessingPdf(false);
  };

  const generateZip = async () => {
    try {
      const folderName = `${registrationId}_${patientName}_${hospitalName}`;

      const zip = new JSZip();
      const folder = zip.folder(folderName);

      for (let item of pdfList) {
        const sanitizedDocumentName =
          item.docName?.replace(/[^a-zA-Z0-9 ]/g, "").trim() || "Document";
        folder.file(
          `${registrationId}_${sanitizedDocumentName}.pdf`,
          item.pdfBlob
        );
      }
      const zipBlob = await zip.generateAsync({ type: "blob" });
      saveAs(zipBlob, `${folderName}.zip`);
      setPdfList([]);
    } catch (err) {
      console.error("Error while zipping and downloading PDF:", err);
    }
  };
  const handleMultipleDownloads = (documentsData) => {
    for (let doc of documentsData) {
      generatePDFUsingPython(doc?.documenturlmasters, doc?.documentName);
    }
  };

  const handleSelection = (key, idx) => {
    const modifiedData = mappedDocuments?.map((doc) => {
      if (key === doc.key) {
        doc.value[idx].isSelected = !doc.value[idx].isSelected;
      }
      return doc;
    });
    setMappedDocuments(modifiedData);
  };
  const handleSelectedDoc = (docId) => {
    //Find already selected document
    const idx = selectedDocuments?.findIndex((item) => item.id === docId);
    if (idx !== -1) {
      //remove already present document
      let modifiedData = selectedDocuments;
      modifiedData.splice(idx, 1);
      setSelectedDocuments(modifiedData);
    } else {
      //Add if document is not present
      for (let doc of mappedDocuments) {
        let selectedDoc = doc.value.find((item) => item.id === docId);
        if (selectedDoc) {
          setSelectedDocuments([...selectedDocuments, selectedDoc]);
          break;
        }
      }
    }
  };
  const handleMergeClick = (value, key) => {
    let urlData = [];
    for (let doc of value) {
      if (doc.isSelected) {
        urlData = [...urlData, ...doc.documenturlmasters];
      }
    }
    if (urlData.length > 0) {
      generatePDFUsingPython(urlData, `merged ${key}`);
    } else {
      window.alert("Please select atleat one document");
    }
  };

  // Function to get all selected documents across all document types
  const getAllSelectedDocuments = () => {
    let allSelectedDocs = [];
    mappedDocuments?.forEach((documentType) => {
      const selectedDocs = documentType.value.filter((doc) => doc.isSelected);
      allSelectedDocs = [...allSelectedDocs, ...selectedDocs];
    });
    return allSelectedDocs;
  };

  // OPTION 1: Download all selected documents as ONE merged PDF
  // OPTION 1: Download all selected documents as ONE merged PDF with compression
  const handleDownloadAllSelected = async () => {
    const selectedDocs = getAllSelectedDocuments();

    if (selectedDocs.length === 0) {
      window.alert("Please select at least one document to download");
      return;
    }

    setIsDownloadingSelected(true);

    try {
      // Merge all documenturlmasters from selected documents into one array
      let mergedUrlData = [];
      for (let doc of selectedDocs) {
        mergedUrlData = [...mergedUrlData, ...doc.documenturlmasters];
      }

      // Prepare images with compression enabled
      const imagesUrl = mergedUrlData.map((image) => ({
        image: image.documentUrl,
        compressionPossible: true,
      }));

      if (imagesUrl.length > 0) {
        // Set aggressive compression target for merged documents
        const targetSize = 500; // Set to 500KB for aggressive compression (less than 1MB)

        let response = await AuthServices.loadImagesBase64UsingPython(
          { images: imagesUrl },
          setPercentage,
          setNetSpeed,
          targetSize
        );

        downloadPdf(response.data, "merged_selected_documents");
      }

      // Clear all selections after successful download
      clearAllSelections();
    } catch (error) {
      handleApiErrorResponses(error);
    } finally {
      setIsDownloadingSelected(false);
    }
  };

  // Function to get count of selected documents
  const getSelectedCount = () => {
    return getAllSelectedDocuments().length;
  };

  const getMappedDocuments = async () => {
    try {
      const response = await CaseServices.getMappedDocuments(caseId);
      console.log("mapped dcuments:", response?.data);
      let data = [];
      for (let docType in response.data.mappedDocuments) {
        let keyData = response.data.mappedDocuments[docType];
        keyData = keyData.map((doc) => {
          return { ...doc, isSelected: false };
        });

        // Check if this is an Enhancement document type
        const isEnhancement = docType.toUpperCase().includes("ENHANCEMENT");

        if (isEnhancement) {
          // Descending order for Enhancement documents (3, 2, 1)
          keyData.sort((a, b) => {
            return b.documentName.localeCompare(a.documentName, undefined, {
              numeric: true,
              sensitivity: "base",
            });
          });
        } else {
          // Ascending order for all other documents (1, 2, 3)
          keyData.sort((a, b) => {
            return a.documentName.localeCompare(b.documentName, undefined, {
              numeric: true,
              sensitivity: "base",
            });
          });
        }

        data.push({
          key: docType,
          value: keyData,
        });
      }

      // Custom sort for parent array
      data.sort((a, b) => {
        // Check if both are enhancement types
        const aIsEnhancement = a.key.toUpperCase().includes("ENHANCEMENT");
        const bIsEnhancement = b.key.toUpperCase().includes("ENHANCEMENT");

        // If both are enhancements, sort them in descending order (ENHANCEMENT2 before ENHANCEMENT1)
        if (aIsEnhancement && bIsEnhancement) {
          return b.key.localeCompare(a.key, undefined, {
            numeric: true,
            sensitivity: "base",
          });
        }

        // Otherwise, use normal ascending sort
        return a.key.localeCompare(b.key, undefined, {
          numeric: true,
          sensitivity: "base",
        });
      });

      setMappedDocuments(data);
    } catch (error) {
      handleApiErrorResponses(error);
    }
  };

  useEffect(() => {
    getMappedDocuments();
  }, []);

  return (
    <div>
      <div className="flex justify-end items-center mb-4">
        {/* <div>
          <button
            className="flex gap-2 items-center text-white text-sm font-semibold bg-[#017C57] rounded-full py-2 px-6 cursor-pointer disabled:bg-gray-400 disabled:cursor-not-allowed"
            onClick={handleDownloadAllSelected}
            disabled={isDownloadingSelected || getSelectedCount() === 0}
          >
            {isDownloadingSelected ? (
              <>
                <CircularProgress size={16} sx={{ color: "white" }} />
                Downloading...
              </>
            ) : (
              <>
                <img src={DownloadIcon} alt="download-icon" />
                Download Selected Documents ({getSelectedCount()})
              </>
            )}
          </button>
        </div> */}

        <div
          style={{ border: "1px solid #E4E4E4" }}
          className="w-[30%] flex items-center gap-2 rounded-[8px] px-4 py-[6px]"
        >
          <img src={SearchIcon} alt="search-icon" />
          <input
            type="text"
            placeholder="Search Documents"
            style={{ border: "0" }}
            className="outline-none"
            onChange={(e) => setSearchKey(e.target.value)}
          />
        </div>
      </div>
      {pdfList?.length > 0 && (
        <div className="flex items-start border-2 border-solid border-[#d5d5d5] px-4 py-2 mt-1 rounded-[8px]">
          <div className="flex-1">
            <div className="font-semibold text-xl">PDF List</div>
            {pdfList?.length > 0 &&
              pdfList?.map((pdf, idx) => {
                return (
                  <div
                    key={idx}
                    className="group flex items-center gap-1 p-2 hover:bg-gray-100 rounded-md cursor-pointer"
                  >
                    {idx + 1 + ". " + pdf.docName}{" "}
                    <img
                      src={RemoveIcon}
                      alt="remove-icon"
                      className="hidden group-hover:block w-5 h-5 cursor-pointer"
                      onClick={() => {
                        let tempData = [...pdfList];
                        tempData.splice(idx, 1);
                        setPdfList([...tempData]);
                      }}
                    />
                  </div>
                );
              })}
          </div>

          <div
            className="flex-shrink-0 text-[#017C57] border-2 border-[#017C57] border-solid px-8 py-3 rounded-full cursor-pointer"
            onClick={generateZip}
          >
            Download Zip
          </div>
        </div>
      )}
      {selectedDocuments?.length > 0 && (
        <div className="max-h-[250px] sticky top-0 border-2 border-solid border-[#d5d5d5] bg-white px-4 py-2 mt-1 rounded-[8px] z-[1204] overflow-y-auto">
          <div className="flex justify-between items-center">
            <div className="font-semibold text-xl">Selected Documents</div>
            <div className="flex items-center gap-2">
              <input
                type="text"
                placeholder="Enter PDF Name"
                onChange={(e) => setPdfDocName(e.target.value)}
                value={pdfDocName}
                className="w-[300px] px-3 py-2 rounded-[8px] mb-2 border-2 border-solid border-[#d5d5d5]"
              />
              {processingPdf ? (
                <CircularProgress />
              ) : (
                <div
                  className="text-white bg-[#017C57] px-8 py-2 rounded-full cursor-pointer"
                  onClick={() => {
                    pdfDocName
                      ? generatePdfList()
                      : window.alert(
                          "Please Enter PDF Name before proceeding."
                        );
                  }}
                >
                  Create PDF
                </div>
              )}
            </div>
          </div>

          <div>
            {selectedDocuments?.length > 0 &&
              selectedDocuments?.map((doc, idx) => {
                return (
                  <div
                    key={idx}
                    className="group flex items-center justify-between p-2 hover:bg-gray-100 rounded-md cursor-pointer"
                  >
                    <span>{idx + 1 + ". " + doc?.documentName}</span>
                  </div>
                );
              })}
          </div>
        </div>
      )}
      {mappedDocuments?.map((document, idx) => {
        return (
          <div key={idx} className="mt-8">
            <div className="flex justify-between mb-2">
              <div className="text-xl font-semibold">
                {document?.key
                  ?.replace(/(DOCUMENT)/, " $1")
                  .replace(/(ONDISCHARGE)/, "ON DISCHARGE")
                  .replace(/(DURINGTREATMENT)/, "DURING TREATMENT")}
              </div>
              {document?.value.length > 0 &&
                (documentDownloading === idx ? (
                  <CircularProgress />
                ) : (
                  <div className="flex gap-2">
                    <div
                      className="flex gap-1 items-center text-white text-xs 2xl:text-sm bg-[#017C57] rounded-full py-2 px-4 cursor-pointer"
                      onClick={() => {
                        setDocumentDownloading(idx);
                        handleMultipleDownloads(document?.value);
                      }}
                    >
                      <img src={DownloadIcon} alt="download-icon" />
                      {`All ${document.key}`}
                    </div>
                    <div
                      className="text-xs 2xl:text-sm text-white bg-[#017C57] rounded-full py-2 px-4 cursor-pointer"
                      onClick={() => {
                        setMergeDocumentDownloading(idx);
                        handleMergeClick(document?.value, document?.key);
                      }}
                    >{`Merge ${document?.key}`}</div>
                  </div>
                ))}
            </div>

            <div
              style={{ borderBottom: "1px solid #E4E4E4", marginBlock: "20px" }}
            />
            {document?.value.length > 0 ? (
              <div className="grid xl:grid-cols-3 2xl:grid-cols-4 gap-5">
                {document?.value
                  ?.filter(
                    (doc) =>
                      searchKey === "" ||
                      doc.documentName
                        .toLowerCase()
                        .includes(searchKey.toLowerCase())
                  )
                  .map((doc, index) => {
                    return (
                      doc.documenturlmasters.length > 0 && (
                        <div
                          key={index}
                          style={{ border: "1.5px solid #E4E4E4" }}
                          className="h-[170px] flex flex-col justify-between rounded-[16px] p-6 hovernow"
                        >
                          <div className="text-[#191919] font-semibold flex justify-between items-center">
                            <div className="overflow-hidden flex gap-2">
                              <img src={DocumentIcon} alt="document-icon" />
                              <div
                                className="overflow-hidden whitespace-nowrap text-ellipsis w-full"
                                title={doc.documentName}
                              >
                                {doc.documentName}
                              </div>
                            </div>
                            {doc.documenturlmasters.length > 0 && (
                              <div>
                                <input
                                  type="checkbox"
                                  className="w-5 h-5"
                                  checked={doc.isSelected}
                                  onClick={() => {
                                    handleSelection(document.key, index);
                                    handleSelectedDoc(doc.id);
                                  }}
                                />
                              </div>
                            )}
                          </div>

                          {documentDownloading === idx ||
                          (mergeDocumentDownloading === idx &&
                            doc.isSelected) ||
                          documentSubDownloading === doc.id ? (
                            <CircularProgress />
                          ) : (
                            <div className="flex justify-between">
                              <div
                                style={{ border: "1px solid #017C57" }}
                                className="w-fit flex items-center gap-1 text-sm text-[#017C57] font-semibold bg-[white] rounded-full cursor-pointer px-4 py-2 border-[5px] z-10 "
                                onClick={() => {
                                  setDocumentSubDownloading(doc?.id);
                                  generatePDFUsingPython(
                                    doc?.documenturlmasters,
                                    doc?.documentName
                                  );
                                }}
                              >
                                <img
                                  src={DownloadIconGreen}
                                  alt="download-icon"
                                  height={14}
                                  width={14}
                                />
                                Download
                              </div>
                              {doc.documenturlmasters.length > 0 && (
                                <ReviewDocumentModel
                                  documentDetails={doc}
                                  type="view"
                                />
                              )}
                            </div>
                          )}
                        </div>
                      )
                    );
                  })}
              </div>
            ) : (
              <div className="text-center text-xl font-semibold pb-6">
                No Documents Mapped
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default DownloadDocuments;
